<div class="modal-roles flex flex-col justify-between h-full">
	<div class="modalHeader">
		<div class="flex">
			<div class="titleNewModule">
				<span>{{ data.sk ? translateModal.titleUpdate + data.name : translateModal.title }}</span>
			</div>
			<div class="closeModal">
				<mat-icon (click)="onNoClick()">close</mat-icon>
			</div>
		</div>
	</div>
	<div mat-dialog-content class="modalContent mt-4 h-full">
		<form class="" [formGroup]="formClient">
			<div class="contentGeneral flex flex-wrap">
				<div class="pr-4 w-2/4">
					<div class="form-group">
						<label for=""> {{ translateModal.name }} <span class="asteriks">*</span></label>
						<input
							type="text"
							class="input-app"
							maxlength="50"
							[placeholder]="translateModal.placeholderName"
							formControlName="name"
						/>
						<div *ngIf="f.name.touched && f.name.invalid" class="alert-error">
							<div *ngIf="f.name.errors?.required">{{ translateModal.nameRequired }}</div>
						</div>
					</div>
					<div class="form-group">
						<label for=""> {{ translateModal.code }} <span class="asteriks">*</span></label>
						<input
							type="text"
							class="input-app"
							maxlength="10"
							[placeholder]="translateModal.placeholderCode"
							formControlName="code"
						/>
						<div *ngIf="f.code.touched && f.code.invalid" class="alert-error">
							<div *ngIf="f.code.errors?.required">{{ translateModal.codeRequired }}</div>
						</div>
					</div>
				</div>
				<div class="pl-4 w-2/4">
					<div class="grid" (dragover)="onDragOver()" (dragleave)="onDragLeave($event)">
						<label for=""> {{ translateModal.titleDrag }} </label>
						<div class="inputDrag" [ngClass]="{ 'active-drag': isDragActive }">
							<mat-icon *ngIf="fileUrl === ''" class="mr-2">backup</mat-icon>
							<span *ngIf="fileUrl === ''"> {{ translateModal.textDrag }} </span>
							<img
								*ngIf="fileUrl !== ''"
								src="{{ fileUrl }}"
								class="h-full cursor-pointer"
								alt=""
							/>
							<zf-s3-upload-image
								[version]="'1'"
								[url]="'https://res.cloudinary.com/du4jrqkyo/image/upload/v1549938954/picture.jpg'"
								[urlPresigned]="'https://api-services.mango-soft.com/stage/get-presigned-url'"
								[bucket]="'cdn.mango-soft.com'"
								[folder]="'access-control/files'"
								[client]="'zerofractal'"
								[imageZoom]="false"
								(urlUploaded)="urlUploadedHandle($event)"
								(urlUploadedError)="urlUploadedErrorHandle($event)"
							>
							</zf-s3-upload-image>
						</div>
					</div>
				</div>
				<div class="w-full h-44 pt-5">
					<div class="w-full flex">
						<label> {{ translateModal.textAws }} <span class="asteriks">*</span> </label>
						<div class="ml-4 check">
							<p-inputSwitch
								formControlName="awsAccount"
								(onChange)="handleChange($event)"
							></p-inputSwitch>
						</div>
					</div>
					<div class="accounts w-full pt-5 flex">
						<div class="accounts__id pr-4 w-1/2 h-full">
							<div class="form-group">
								<label for=""> {{ translateModal.accountId }} </label>
								<input
									type="text"
									formControlName="accountId"
									class="input-app"
									autocomplete="disabled"
									placeholder="AKIASOIMKHXQBL2GKIM"
								/>
							</div>
						</div>
						<div class="accounts__keys pl-4 w-1/2 h-full">
							<div class="form-group">
								<label for=""> {{ translateModal.accessKey }}</label>
								<mg-input-password
									placeholder="*******"
									[disabled]="disableInputs"
									(valueInput)="dataSecretKey($event)"
								></mg-input-password>
							</div>
							<div class="form-group">
								<label for=""> {{ translateModal.secretKey }}</label>
								<mg-input-password
									placeholder="*******"
									[disabled]="disableInputs"
									(valueInput)="dataAccessKey($event)"
								></mg-input-password>
							</div>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
	<div mat-dialog-actions class="footer-modal">
		<div class="px-2">
			<button class="mg-button secundaryButton" (click)="onNoClick()">
				{{ translateModal.buttonCancel }}
			</button>
		</div>
		<div class="pl-2">
			<button
				class="mg-button primaryButton"
				[disabled]="validatedRequiredForm()"
				(click)="createClient()"
			>
				{{ translateModal.buttonSave }}
			</button>
		</div>
	</div>
</div>
